import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import React, {Fragment, useEffect, useRef, useState} from "react";
import {Dialog, Transition} from "@headlessui/react";
import TreeSelectComponent from "../TreeSelectComponent";
import ComboboxComponent from "../Combobox";
import saveItem, {getList} from "../../services/service";
import {toast} from "react-toastify";

export default function ModalEditAccessoriesSide({
                                                     open,
                                                     setOpen,
                                                     row,
                                                     fetchData
                                                 }) {
    const {t} = useTranslation();
    const {token} = useSelector((state) => state.user);
    const cancelButtonRef = useRef(null);
    const [hangleSides, setHangleSides] = useState([])
    const [hangleSideFuncs, setHangleSideFuncs] = useState([])

    const fetchHangleSides = async () => {
        const response = await getList(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/accessories/side/enum/hangleside`,
            token
        );
        if (response.success) {
            setHangleSides(response.data);
        }
    }
    const fetchHangleSideFuncs = async () => {
        const response = await getList(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/accessories/side/enum/hanglesidefunc`,
            token
        );
        if (response.success) {
            setHangleSideFuncs(response.data.map(item => {
                return {
                    id: item.id,
                    name: t(`HangleSideFunc.${item.name}`),
                    value: item.name
                }
            }));
        }
    }

    useEffect(() => {
        fetchHangleSides();
        fetchHangleSideFuncs();
    }, []);

    const handleSubmit = async (evt) => {
        evt.preventDefault();
        const response = await saveItem(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/accessories/side`,
            token,
            {
                ...row
            }
        );
        if (response.success) {

            setOpen(false);
            fetchData();
            toast.success(t('action.add_success'), {
                position: "bottom-right",
                autoClose: 3000,
                closeOnClick: true,
                className: "add-success"
            });
        }
    };

    function handleHangleSide(value) {
    }

    function handleHangleSideFunc(value) {
        row.hangleSideFunc = value.value
    }

    return (
        <Transition.Root show={open} as={Fragment}>
            <Dialog
                as="div"
                className="relative z-10"
                initialFocus={cancelButtonRef}
                onClose={setOpen}
            >
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75"/>
                </Transition.Child>

                <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div className="flex items-end justify-center min-h-full p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel
                                className="relative px-4 pt-5 pb-4 text-left transition-all transform bg-white rounded-lg shadow-xl  sm:my-8 sm:w-full sm:max-w-lg sm:p-6 ">
                                <form onSubmit={handleSubmit}>
                                    <div className="sm:mb-5">
                                        <Dialog.Title
                                            as="h3"
                                            className="text-lg font-medium leading-6 text-gray-900 "
                                        >
                                            {t('add_profile_system')}
                                        </Dialog.Title>
                                        <div className="grid grid sm:grid-cols-12 gap-2">
                                            <div className="mt-5 col-span-12 sm:col-span-12">
                                                <label
                                                    htmlFor="priority"
                                                    className="block text-sm font-medium text-gray-700"
                                                >
                                                    {t('side')}
                                                </label>
                                                <input
                                                    type="text"
                                                    name="priority"
                                                    id="priority"
                                                    required
                                                    value={row?.hangleSide}
                                                    disabled={true}
                                                    className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                />

                                            </div>


                                            <div className="mt-5 col-span-12 sm:col-span-12">
                                                <ComboboxComponent
                                                    label={t('value')}
                                                    data={hangleSideFuncs}
                                                    item={row?.hangleSideFunc ?
                                                        hangleSideFuncs.find(
                                                            (item) => item.value === row.hangleSideFunc
                                                        )
                                                        : null}
                                                    onChange={handleHangleSideFunc}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="mt-8 sm:mt-10 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                                        <button
                                            type="submit"
                                            className="inline-flex justify-center w-full px-4 py-2 text-base font-medium text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:col-start-2 sm:text-sm"
                                        >
                                            {t('save')}
                                        </button>
                                        <button
                                            type="button"
                                            className="inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:col-start-1 sm:mt-0 sm:text-sm"
                                            onClick={() => setOpen(false)}
                                            ref={cancelButtonRef}
                                        >
                                            {t('cancel')}
                                        </button>
                                    </div>
                                </form>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
}